// Gating de acceso por sesión (eje login) — fuente única de verdad.
//
// Este módulo responde SOLO la pregunta: "¿necesita sesión activa para abrirse?"
// No toca el eje pago (free vs MiPAE+): eso vive en plan.js.
//
// IDs canónicos = IDs de tarjeta de Home.jsx / appState de App.jsx.
const REQUIERE_SESION = new Set([
  'rapido',         // PAE Rápido — acción IA
  'detallado',      // PAE Detallado — acción IA (muro de pago adicional en plan.js)
  'revisa',         // Revisa — acción IA
  'bitacora',       // requiere perfil completado
  'prepara-examen', // guía personalizada de fin de etapa
  'bibliografia',   // disponible solo con cuenta
]);

// ¿Este módulo exige sesión activa para abrirse?
export function requiereSesion(moduloId) {
  return REQUIERE_SESION.has(moduloId);
}

// ¿Puede el usuario abrir este módulo?
// Si no requiere sesión → siempre true.
// Si requiere sesión    → solo si isLoggedIn.
export function puedeAbrir(moduloId, { isLoggedIn }) {
  if (!requiereSesion(moduloId)) return true;
  return !!isLoggedIn;
}
